import React, { useRef } from 'react';
import { IconButton, palettes, RegularTitle } from '@indigo-ag/component-module';
import { faUpload } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';

import i18next from 'core/i18n';
import { createStylesHook } from 'shared/hooks/createStylesHook';
import { text } from 'shared';

const BlueRegularTitle = styled(RegularTitle)`
  color: ${palettes.brand.blue.base};
`;

export const useStyles = createStylesHook(() => ({
  selectFilesDropbox: {
    alignItems: 'center',
    backgroundColor: palettes.brand.blue.lightest,
    border: `1px dashed ${palettes.brand.blue.base}`,
    borderRadius: 12,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 400,
    height: 100,
    justifyContent: 'center',
    margin: '0 0 25px',
    padding: '4rem 0',
    width: 400
  }
}));

interface UploadDocumentsProps {
  onNewFiles?: (files: File[]) => void;
}

export const UploadDocuments: React.FunctionComponent<UploadDocumentsProps> = ({ onNewFiles }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const onChooseFile = (): void => {
    (fileInputRef as React.MutableRefObject<HTMLInputElement>).current.click();
  };

  const onFileDrop = (event: React.DragEvent<HTMLDivElement>): void => {
    const fileData: File[] = Array.from(event.dataTransfer.files);
    event.preventDefault();
    event.stopPropagation();

    if (onNewFiles) {
      onNewFiles(fileData);
    }

    (fileInputRef as React.MutableRefObject<HTMLInputElement>).current.value = '';
  };

  const onDragOver = (event: React.DragEvent<HTMLDivElement>): void => {
    event.stopPropagation();
    event.preventDefault();
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const fileData: File[] = Array.from(event.target.files || []);

    if (onNewFiles) {
      onNewFiles(fileData);
    }

    (fileInputRef as React.MutableRefObject<HTMLInputElement>).current.value = '';
  };

  return (
    <>
      <input ref={fileInputRef} type="file" accept="*" multiple onChange={handleFileUpload} className="display-none" />
      <div onClick={onChooseFile} className={classes.selectFilesDropbox} onDrop={onFileDrop} onDragOver={onDragOver}>
        <IconButton label="Upload" icon={faUpload} />
        <BlueRegularTitle>{text.firstLetterUppercase(i18next.t('dragAndDropOrSelectFiles'))}</BlueRegularTitle>
      </div>
    </>
  );
};
